import { Subscription } from "@falcon/services";

export function getEditAccountDetailsAlertWording(subscription: Subscription | undefined): string {

    if (subscription && subscription.renewalPaymentFailed) {
        return `Due to missed payment this action is not allowed`;
    } else if (subscription && subscription.allPoliciesAreCancelled) {
        return `Due to policy cancellation this action is not allowed`;
    } else {
        return `This action is not allowed`;
    }
}

export function getCookieDomain(hostname: string) {
    const topLevelDomainsToCheck = [".com", ".co.uk"];
    for (const tld of topLevelDomainsToCheck) {
        if (hostname.endsWith(tld)) {
            const hostnameWithoutTld = hostname.replace(new RegExp(`${tld}$`), "");
            const subdomainsAndDomain = hostnameWithoutTld.split(".");
            const domain = subdomainsAndDomain[subdomainsAndDomain.length - 1];
            return domain + tld;
        }
    }
    return hostname;
}

export function setCookie(name: string, value: any, millis?: number) {
    let expires = "";
    const domain = `; domain=${getCookieDomain(window.location.hostname)}`
    if (millis) {
        const date = new Date();
        date.setTime(date.getTime() + millis);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + domain + "; path=/";
}



// WEBPACK FOOTER //
// ./src/components/accountDetails/CommonFunctions.ts